export default __webpack_public_path__ + "static/media/jupiter-artland.a2688497.webp";